import { render, staticRenderFns } from "./sopConfig.vue?vue&type=template&id=5bfd4023&"
import script from "./sopConfig.vue?vue&type=script&lang=js&"
export * from "./sopConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bfd4023')) {
      api.createRecord('5bfd4023', component.options)
    } else {
      api.reload('5bfd4023', component.options)
    }
    module.hot.accept("./sopConfig.vue?vue&type=template&id=5bfd4023&", function () {
      api.rerender('5bfd4023', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/sopConfig.vue"
export default component.exports